/* Este arquivo é gerado automaticamente */

import agentReportPolygonInsight from './agentReport/agentReportPolygonInsight/agentReportPolygonInsight.definition'
import generateAgentReportHeatmapData from './agentReport/heatmap/generateAgentReportHeatmapData.definition'
import searchAgentIntersections from './agentReport/intersections/searchAgentIntersections.definition'
import appSebraeAttendanceMedianStats from './appSebrae/appSebraeAttendanceMedian/stats/appSebraeAttendanceMedianStats.definition'
import appSebraeAttendanceMetrics from './appSebrae/appSebraeAttendanceMetrics/appSebraeAttendanceMetrics.definition'
import appSebraeNewAttendance from './appSebrae/appSebraeNewAttendance/newAttendanceAppSebrae/appSebraeNewAttendance.definition'
import synchronizeAppSebrae from './appSebrae/appSebraeNewAttendance/synchronizeAppSebrae/synchronizeAppSebrae.definition'
import synchronizeAppSebraeV2Backfill from './appSebrae/appSebraeNewAttendance/synchronizeAppSebraeV2Backfill/synchronizeAppSebraeV2Backfill.definition'
import appSebraeAtendimentoRead from './appSebrae/atendimento/read/appSebraeAtendimentoRead.definition'
import attendanceGeoReport from './appSebrae/attendanceGeoReport/attendanceGeoReport.definition'
import appSebraeAttendanceLocationStats from './appSebrae/attendanceLocationStats/appSebraeAttendanceLocationStats.definition'
import attendanceRadar from './appSebrae/attendanceRadar/attendanceRadar.definition'
import fetchAttendanceProximity from './appSebrae/fetchAttendanceProximity/fetchAttendanceProximity.definition'
import fetchItinerary from './appSebrae/fetchItinerary/fetchItinerary.definition'
import fetchLegalEntityDetails from './appSebrae/fetchLegalEntityDetails/fetchLegalEntityDetails.definition'
import fetchLegalEntityItineraryStatus from './appSebrae/fetchLegalEntityItineraryStatus/fetchLegalEntityItineraryStatus.definition'
import generateItinerary from './appSebrae/generateItinerarySentinel/generateItinerary.definition'
import polygonInsight from './appSebrae/geoInsight/polygonInsight/polygonInsight.definition'
import agentPolygonInsight from './appSebrae/geoInsight/polygonInsightAgent/agentPolygonInsight.definition'
import geoSearch from './appSebrae/geoSearch/geoSearch.definition'
import legalEntityInsight from './appSebrae/legalEntityInsight/legalEntityInsight.definition'
import legalEntityNewlyOpened from './appSebrae/legalEntityNewlyOpened/legalEntityNewlyOpened.definition'
import legalEntitySearchWithGeo from './appSebrae/legalEntitySearchWithGeo/legalEntitySearchWithGeo.definition'
import legalEntityAppSebraeAttendanceStats from './appSebrae/legalEntityStats/legalEntityAppSebraeAttendanceStats.definition'
import reverseGeocoding from './appSebrae/reverseGeocoding/reverseGeocoding.definition'
import appSebraeSearchAddress from './appSebrae/searchAddress/appSebraeSearchAddress.definition'
import appSebraeSearchAddressResolve from './appSebrae/searchAddress/resolve/appSebraeSearchAddressResolve.definition'
import searchLegalEntity from './appSebrae/searchLegalEntity/searchLegalEntity.definition'
import selectItinerary from './appSebrae/selectItinerary/selectItinerary.definition'
import appSebraeAttendanceStats from './appSebrae/stats/appSebraeAttendanceStats.definition'
import agentAvailabilityCheck from './appSebraeMobility/agentAvailabilityCheck/agentAvailabilityCheck.definition'
import agentAvailabilityStop from './appSebraeMobility/agentAvailabilityStop/agentAvailabilityStop.definition'
import agentCheckStream from './appSebraeMobility/agentCheckStream/agentCheckStream.definition'
import agentGeolocation from './appSebraeMobility/agentGeolocation/agentGeolocation.definition'
import agentRequestClose from './appSebraeMobility/agentRequest/close/agentRequestClose.definition'
import agentRequestList from './appSebraeMobility/agentRequest/list/agentRequestList.definition'
import agentRequestStart from './appSebraeMobility/agentRequest/start/agentRequestStart.definition'
import agentRequestResponse from './appSebraeMobility/agentRequestResponse/agentRequestResponse.definition'
import entrepreneurAgentCheck from './appSebraeMobility/entrepreneurAgentCheck/entrepreneurAgentCheck.definition'
import entrepreneurAgentCloseRequest from './appSebraeMobility/entrepreneurAgentRequest/close/entrepreneurAgentCloseRequest.definition'
import entrepreneurAgentRequestDetail from './appSebraeMobility/entrepreneurAgentRequest/detail/entrepreneurAgentRequestDetail.definition'
import entrepreneurAgentRequest from './appSebraeMobility/entrepreneurAgentRequest/entrepreneurAgentRequest.definition'
import entrepreneurAgentRequestHistory from './appSebraeMobility/entrepreneurAgentRequest/history/entrepreneurAgentRequestHistory.definition'
import expiredAttendanceCancellation from './appSebraeMobility/expiredAttendanceCancellation/expiredAttendanceCancellation.definition'
import appSebraeMobilityImageProxy from './appSebraeMobility/imageProxy/appSebraeMobilityImageProxy.definition'
import operationalMonitoring from './appSebraeMobility/operationalMonitoring/operationalMonitoring.definition'
import operationalMonitoringSnapshot from './appSebraeMobility/operationalMonitoringSnapshot/operationalMonitoringSnapshot.definition'
import fetchAttendantFromRadarAli from './attendant/fetchAttendantFromRadarAli/fetchAttendantFromRadarAli.definition'
import attendantRead from './attendant/read/attendantRead.definition'
import attendantServiceUnitRead from './attendantServiceUnit/read/attendantServiceUnitRead.definition'
import seedCityGovernmentTransparency from './cityGovernmentTransparency/seedCityGovermnentTransparency/seedCityGovernmentTransparency.definition'
import cityCensusByAreaRead from './cityIbgeCensus/cityCensusByArea/read/cityCensusByAreaRead.definition'
import cityCensusByPopulationRead from './cityIbgeCensus/cityCensusByPopulation/read/cityCensusByPopulationRead.definition'
import fetchLatestCityCensus from './cityIbgeCensus/fetchLatestCityCensus/fetchLatestCityCensus.definition'
import cityIbgeCensusRead from './cityIbgeCensus/read/cityIbgeCensusRead.definition'
import seedCityCensus from './cityIbgeCensus/seedCityCensus/seedCityCensus.definition'
import legalEntityUnnestCnaeRead from './cnae/legalEntityUnnestCnae/read/legalEntityUnnestCnaeRead.definition'
import cnaeRead from './cnae/read/cnaeRead.definition'
import updateCnaes from './cnae/updateCnaes/updateCnaes.definition'
import cnaeClassRead from './cnaeClass/read/cnaeClassRead.definition'
import cnaeDivisionRead from './cnaeDivision/read/cnaeDivisionRead.definition'
import cnaeGroupRead from './cnaeGroup/read/cnaeGroupRead.definition'
import cnaeSectionRead from './cnaeSection/read/cnaeSectionRead.definition'
import cnaeSegmentRead from './cnaeSegment/read/cnaeSegmentRead.definition'
import cnaeSubclassRead from './cnaeSubclass/read/cnaeSubclassRead.definition'
import fetchCourseProduct from './courseProduct/fetchCourseProduct/fetchCourseProduct.definition'
import courseProductRead from './courseProduct/read/courseProductRead.definition'
import courseRegisterIndividualRead from './courseRegisterIndividual/read/courseRegisterIndividualRead.definition'
import fetchDataSourceHelpers from './dataSource/fetchDataSourceHelpers/fetchDataSourceHelpers.definition'
import dataSourceRead from './dataSource/read/dataSourceRead.definition'
import distinctLegalEntitiesEmissorNfeStats from './distinctLegalEntitiesEmissorNfe/stats/distinctLegalEntitiesEmissorNfeStats.definition'
import distinctLegalEntitiesEmissorNfeSize from './distinctLegalEntitiesEmissorNfeSize/queries/distinctLegalEntitiesEmissorNfeSize/distinctLegalEntitiesEmissorNfeSize.definition'
import eadEnrollmentStats from './ead/enrollmentStats/eadEnrollmentStats.definition'
import legalEntityEadAttendanceStats from './ead/legalEntityStats/legalEntityEadAttendanceStats.definition'
import eadPortfolioEnrollmentStats from './ead/portfolioEnrollmentStats/eadPortfolioEnrollmentStats.definition'
import eadPortfolioAttendanceStats from './ead/portfolioStats/eadPortfolioAttendanceStats.definition'
import eadAttendanceStats from './ead/stats/eadAttendanceStats.definition'
import establishmentRead from './establishment/read/establishmentRead.definition'
import fetchOpenStreetMapId from './geo/city/fetchOpenStreetMapId/fetchOpenStreetMapId.definition'
import cityRead from './geo/city/read/cityRead.definition'
import geoCommunityCreate from './geo/community/create/geoCommunityCreate.definition'
import geoCommunityDelete from './geo/community/delete/geoCommunityDelete.definition'
import geoCommunityFetch from './geo/community/fetch/geoCommunityFetch.definition'
import geoCommunityList from './geo/community/list/geoCommunityList.definition'
import geoCommunityUpdate from './geo/community/update/geoCommunityUpdate.definition'
import countryRead from './geo/country/read/countryRead.definition'
import fetchAllDistricts from './geo/districts/fetchAllDistricts/fetchAllDistricts.definition'
import fetchDistricts from './geo/districts/fetchDistricts/fetchDistricts.definition'
import fetchBuildings from './geo/fetchBuildings/fetchBuildings.definition'
import geoUpdateOrchestrator from './geo/geoUpdateOrchestrator/geoUpdateOrchestrator.definition'
import geocodeAddress from './geo/internalGeocode/geocodeAddress/geocodeAddress.definition'
import legalEntityMassGeocode from './geo/internalGeocode/legalEntityMassGeocode/legalEntityMassGeocode.definition'
import processAddresses from './geo/internalGeocode/processAddresses/processAddresses.definition'
import searchAddress from './geo/internalGeocode/searchAddress/searchAddress.definition'
import streetSearchRefreshViews from './geo/internalGeocode/streetSearchRefreshViews/streetSearchRefreshViews.definition'
import legalEntityMassPartialGeocode from './geo/legalEntityMassPartialGeocode/legalEntityMassPartialGeocode.definition'
import geoList from './geo/list/geoList.definition'
import macroRegionRead from './geo/macroRegion/read/macroRegionRead.definition'
import mesoRegionRead from './geo/mesoRegion/read/mesoRegionRead.definition'
import microRegionRead from './geo/microRegion/read/microRegionRead.definition'
import geoMunicipalityImportUrbanArea from './geo/municipality/importUrbanArea/geoMunicipalityImportUrbanArea.definition'
import geoNeighborhoodCoverageAfter from './geo/neighborhood/editCoverageArea/geoNeighborhoodCoverageAfter.definition'
import geoNeighborhoodEditCoverageArea from './geo/neighborhood/editCoverageArea/geoNeighborhoodEditCoverageArea.definition'
import geoNeighborhoodFetch from './geo/neighborhood/fetch/geoNeighborhoodFetch.definition'
import fetchShapesFromOpenStreetMap from './geo/neighborhood/process/fetchShapesFromOpenStreetMap/fetchShapesFromOpenStreetMap.definition'
import neighborhoodLowerQualityBoundaries from './geo/neighborhood/process/neighborhoodLowerQualityBoundaries/neighborhoodLowerQualityBoundaries.definition'
import neighborhoodProcess from './geo/neighborhood/process/neighborhoodProcess.definition'
import neighborhoodNewShapes from './geo/neighborhood/process/prepareForNewShapes/neighborhoodNewShapes.definition'
import seedNeighborhoodNullableCenter from './geo/neighborhood/process/seedNeighborhoodNullableCenter/seedNeighborhoodNullableCenter.definition'
import neighborhoodRead from './geo/neighborhood/read/neighborhoodRead.definition'
import geoNeighborhoodSmartMapping from './geo/neighborhood/smartMapping/geoNeighborhoodSmartMapping.definition'
import geoReverseGeocoding from './geo/reverseGeocoding/geoReverseGeocoding.definition'
import ruralEnvironmentalRegistryFetch from './geo/ruralEnvironmentalRegistry/fetch/ruralEnvironmentalRegistryFetch.definition'
import ruralEnvironmentalRegistryProcess from './geo/ruralEnvironmentalRegistry/process/ruralEnvironmentalRegistryProcess.definition'
import fetchOpenStreetMapStateId from './geo/state/fetchOpenStreetMapId/fetchOpenStreetMapStateId.definition'
import stateRead from './geo/state/read/stateRead.definition'
import fetchAllRoads from './geo/street/fetchAllRoads/fetchAllRoads.definition'
import fetchAllStreetsAndWays from './geo/street/fetchAllStreetsAndWays/fetchAllStreetsAndWays.definition'
import fetchStreetsAndWays from './geo/street/fetchStreetsAndWays/fetchStreetsAndWays.definition'
import fetchStreetsFromIbge from './geo/street/fetchStreetsFromIbge/fetchStreetsFromIbge.definition'
import streetFullGeocoding from './geo/street/fullGeocoding/streetFullGeocoding.definition'
import streetRead from './geo/street/read/streetRead.definition'
import refreshPgRoutingNetwork from './geo/street/refreshPgRoutingNetwork/refreshPgRoutingNetwork.definition'
import seedBrasiliaAbbreviatures from './geo/street/seedBrasiliaAbbreviatures/seedBrasiliaAbbreviatures.definition'
import seedStreetCollection from './geo/street/seedCollections/seedStreetCollection.definition'
import seedStreetRoadReference from './geo/street/seedStreetRoadReference/seedStreetRoadReference.definition'
import districtStreetIntersectionProcess from './geo/street/streetIntersection/districtStreetIntersetion/process/districtStreetIntersectionProcess.definition'
import districtStreetIntersectionRead from './geo/street/streetIntersection/districtStreetIntersetion/read/districtStreetIntersectionRead.definition'
import neighborhoodStreetIntersectionProcess from './geo/street/streetIntersection/neighborhoodStreetIntersetion/process/neighborhoodStreetIntersectionProcess.definition'
import neighborhoodStreetIntersectionRead from './geo/street/streetIntersection/neighborhoodStreetIntersetion/read/neighborhoodStreetIntersectionRead.definition'
import fetchAllSuburbs from './geo/suburbs/fetchAllSuburbs/fetchAllSuburbs.definition'
import fetchSuburbs from './geo/suburbs/fetchSuburbs/fetchSuburbs.definition'
import geoSyncFetch from './geo/sync/fetch/geoSyncFetch.definition'
import updateGeoSchema from './geo/updateGeoSchema/updateGeoSchema.definition'
import wayRead from './geo/way/read/wayRead.definition'
import indicatorTrends from './indicatorTrends/indicatorTrends.definition'
import individualAnonymization from './individual/anonymization/individualAnonymization.definition'
import individualCpfValidator from './individual/cpfValidator/individualCpfValidator.definition'
import individualFetch from './individual/fetch/individualFetch.definition'
import individualRead from './individual/read/individualRead.definition'
import buildInsightsExport from './insight/export/buildInsightsExport.definition'
import insightSendEmail from './insight/insightSendEmail/insightSendEmail.definition'
import insightList from './insight/list/insightList.definition'
import insightRead from './insight/read/insightRead.definition'
import insightTopInsightsByRelevanceRead from './insight/recommendations/insightTopInsightsByRelevanceRead.definition'
import insightSolutionSearch from './insight/solutionSearch/insightSolutionSearch.definition'
import kpiYearlyCumulativeStats from './kpiYearlyCumulative/stats/kpiYearlyCumulativeStats.definition'
import cnpjValidator from './legalEntity/cnpjValidator/cnpjValidator.definition'
import createLegalEntitySearchIndex from './legalEntity/createSearchIndex/createLegalEntitySearchIndex.definition'
import legalEntityFetch from './legalEntity/fetch/legalEntityFetch.definition'
import legalEntityFetchLogs from './legalEntity/read/fetchLogs/legalEntityFetchLogs.definition'
import legalEntityRead from './legalEntity/read/legalEntityRead.definition'
import legalEntityRevalidateLocation from './legalEntity/revalidateLocation/legalEntityRevalidateLocation.definition'
import legalEntityStats from './legalEntity/stats/legalEntityStats.definition'
import attendanceRefreshViews from './legalEntityAttendance/attendanceRefreshViews/attendanceRefreshViews.definition'
import disproportionatePublicRead from './legalEntityAttendance/disproportionateAttention/disproportionatePublic/read/disproportionatePublicRead.definition'
import legalEntityAttendanceFetch from './legalEntityAttendance/fetch/legalEntityAttendanceFetch.definition'
import legalEntityAttendanceList from './legalEntityAttendance/list/legalEntityAttendanceList.definition'
import legalEntityAttendanceRead from './legalEntityAttendance/read/legalEntityAttendanceRead.definition'
import legalEntityAttendanceAttendantRead from './legalEntityAttendanceAttendant/read/legalEntityAttendanceAttendantRead.definition'
import legalEntityAttendanceDataSourceRead from './legalEntityAttendanceDataSource/read/legalEntityAttendanceDataSourceRead.definition'
import prependCommaAtCnaes from './legalEntityCnae/prependCommaAtCnaes/prependCommaAtCnaes.definition'
import legalEntityCnaeRead from './legalEntityCnae/read/legalEntityCnaeRead.definition'
import seedLegalEntityCnaes from './legalEntityCnae/seedLegalEntityCnaes/seedLegalEntityCnaes.definition'
import legalEntityGeoprocessingAfterProcess from './legalEntityGeoprocessing/afterProcess/legalEntityGeoprocessingAfterProcess.definition'
import generateHeatmapData from './legalEntityGeoprocessing/heatmap/generateHeatmapData/generateHeatmapData.definition'
import courseEvasionRead from './legalEntityGeoprocessing/map/ead/courseEvasion/courseEvasionRead.definition'
import eadReadCompany from './legalEntityGeoprocessing/map/ead/readCompany/eadReadCompany.definition'
import eadReadEnrollment from './legalEntityGeoprocessing/map/ead/readEnrollment/eadReadEnrollment.definition'
import eadReadStudent from './legalEntityGeoprocessing/map/ead/readStudent/eadReadStudent.definition'
import eadReadStudentCompany from './legalEntityGeoprocessing/map/ead/readStudentCompany/eadReadStudentCompany.definition'
import productMetricRead from './legalEntityGeoprocessing/map/monitor/read/productMetricRead.definition'
import mapDemarcationExportEntities from './legalEntityGeoprocessing/mapDemarcation/exportEntities/mapDemarcationExportEntities.definition'
import mapDemarcationReport from './legalEntityGeoprocessing/mapDemarcation/fetchFromDatabase/mapDemarcationReport.definition'
import legalEntityGeoprocessingProcess from './legalEntityGeoprocessing/process/legalEntityGeoprocessingProcess.definition'
import radar from './legalEntityGeoprocessing/radar/fetchFromDatabase/radar.definition'
import legalEntityGeoprocessingRead from './legalEntityGeoprocessing/read/legalEntityGeoprocessingRead.definition'
import legalEntityIndividualRead from './legalEntityIndividual/read/legalEntityIndividualRead.definition'
import fetchLegalEntityIndicators from './legalEntityProfit/fetchLegalEntityIndicators/fetchLegalEntityIndicators.definition'
import legalEntityIndicatorsRead from './legalEntityProfit/read/legalEntityIndicatorsRead.definition'
import fetchLegalEntityAttendanceSize from './legalEntitySize/queries/fetchLegalEntityAttendanceSize/fetchLegalEntityAttendanceSize.definition'
import legalNatureRead from './legalNature/read/legalNatureRead.definition'
import llmChatCreate from './llmChat/create/llmChatCreate.definition'
import llmChatDelete from './llmChat/delete/llmChatDelete.definition'
import llmChatGet from './llmChat/get/llmChatGet.definition'
import llmChatList from './llmChat/list/llmChatList.definition'
import llmChatUpdate from './llmChat/update/llmChatUpdate.definition'
import llmChatMessageCreate from './llmChatMessage/create/llmChatMessageCreate.definition'
import migrationMigrateOlap from './migration/migrateOlap/migrationMigrateOlap.definition'
import migrationMigrateOltp from './migration/migrateOltp/migrationMigrateOltp.definition'
import fampeAttendedEntitiesImport from './monitor/fampeAttendedEntitiesImport/fampeAttendedEntitiesImport.definition'
import fetchMonitorUploadUrl from './monitor/fetchMonitorUploadUrl/fetchMonitorUploadUrl.definition'
import monitorCourseClassesMetricsImport from './monitor/monitorCourseClassesMetricsImport/monitorCourseClassesMetricsImport.definition'
import monitorEmissorServiceAggregateImport from './monitor/monitorEmissorServiceAggregateImport/monitorEmissorServiceAggregateImport.definition'
import monitorProductMetricImport from './monitor/monitorProductMetricImport/monitorProductMetricImport.definition'
import monitorProductYearlyCumulativeImport from './monitor/monitorProductYearlyCumulativeImport/monitorProductYearlyCumulativeImport.definition'
import monitorProductMetricStats from './monitor/stats/monitorProductMetricStats.definition'
import monitorUsageAnalyticsSummary from './monitor/usageAnalyticsSummary/monitorUsageAnalyticsSummary.definition'
import getMonitorUserPermissions from './monitor/userPermissions/getMonitorUserPermissions.definition'
import updateMonitorUserPermissions from './monitor/userPermissions/updateMonitorUserPermissions.definition'
import monitorUserReportPreferences from './monitor/userReportPreferences/monitorUserReportPreferences.definition'
import monitorAttendanceEntityDistinctStats from './monitorAttendanceEntityDistinct/stats/monitorAttendanceEntityDistinctStats.definition'
import monitorCourseClassesMetricsStats from './monitorClassesMetrics/stats/monitorCourseClassesMetricsStats.definition'
import monitorProductMetricIdsImport from './monitorProductMetricIdsImport/monitorProductMetricIdsImport.definition'
import deregisterDevice from './notifications/deregisterDevice/deregisterDevice.definition'
import attendanceAlertAction from './notifications/email/attendanceAlertAction/attendanceAlertAction.definition'
import sendAttendanceUrgencyAlertEmail from './notifications/email/sendAttendanceUrgencyAlertEmail/sendAttendanceUrgencyAlertEmail.definition'
import sendTimeSeriesAlertEmail from './notifications/email/sendTimeSeriesAlertEmail/sendTimeSeriesAlertEmail.definition'
import systemSendEmail from './notifications/email/systemSendEmail/systemSendEmail.definition'
import getNotifications from './notifications/getNotifications/getNotifications.definition'
import getNotificationSettings from './notifications/getNotificationSettings/getNotificationSettings.definition'
import readNotification from './notifications/readNotification/readNotification.definition'
import registerNewDevice from './notifications/registerNewDevice/registerNewDevice.definition'
import sendTimeSeriesNotification from './notifications/sendTimeSeriesNotification/sendTimeSeriesNotification.definition'
import updateTimeSeriesNotificationSettings from './notifications/updateTimeSeriesNotificationSettings/updateTimeSeriesNotificationSettings.definition'
import productMetricIdsStats from './productMetricIds/stats/productMetricIdsStats.definition'
import reportRead from './report/read/reportRead.definition'
import reportOutputRead from './reportOutput/read/reportOutputRead.definition'
import segmentRead from './segment/read/segmentRead.definition'
import agentPolygonSmartMapping from './sentinel/agentPolygonSmartMapping/agentPolygonSmartMapping.definition'
import agentPolygonSmartMappingServiceArea from './sentinel/agentPolygonSmartMapping/agentPolygonSmartMappingServiceArea.definition'
import geographicalContainment from './sentinel/hooks/geographicalContainment/geographicalContainment.definition'
import serviceUnitGeocode from './serviceUnitGeocode/serviceUnitGeocode.definition'
import serviceUnitGeoprocessingRead from './serviceUnitGeoprocessing/read/serviceUnitGeoprocessingRead.definition'
import streetViewReverseGeocoding from './streetViewReverseGeocoding/streetViewReverseGeocoding.definition'
import fetchSummary from './summary/fetchSummary/fetchSummary.definition'
import abortPendingUserQueries from './system/abortPendingUserQueries/abortPendingUserQueries.definition'
import appSebraeDistantAttendanceStats from './system/appSebraeDistantAttendanceStats/appSebraeDistantAttendanceStats.definition'
import systemCheck from './system/check/systemCheck.definition'
import systemCheckImports from './system/checkImports/systemCheckImports.definition'
import importCagedData from './system/importCaged/importCagedData.definition'
import systemImportEad from './system/importEad/systemImportEad.definition'
import importFtpPostgresDumps from './system/importFtpPostgresDumps/importFtpPostgresDumps.definition'
import monitorStats from './system/monitorStats/monitorStats.definition'
import overviewStats from './system/overviewStats/overviewStats.definition'
import systemPrepareCache from './system/prepareCache/systemPrepareCache.definition'
import systemPropagateToOlap from './system/propagateToOlap/systemPropagateToOlap.definition'
import systemExportPostgresDump from './system/systemExportPostgresDump/systemExportPostgresDump.definition'
import systemExportRfbSftp from './system/systemExportRfbSftp/systemExportRfbSftp.definition'
import systemImportFailureReporter from './system/systemImportFailureReporter/systemImportFailureReporter.definition'
import systemImportPostgresDump from './system/systemImportPostgresDump/systemImportPostgresDump.definition'
import systemImportSebraeNaSuaEmpresa from './system/systemImportSebraeNaSuaEmpresa/systemImportSebraeNaSuaEmpresa.definition'
import systemSynchronizeAttendanceOlap from './system/systemSynchronizeAttendanceOlap/systemSynchronizeAttendanceOlap.definition'
import systemUserAuthEventLog from './system/systemUserAuthEventLog/systemUserAuthEventLog.definition'
import timeSeriesRead from './timeSeries/read/timeSeriesRead.definition'
import fetchLegalEntitiesCoordinates from './uge/fetchLegalEntitiesCoordinates/fetchLegalEntitiesCoordinates.definition'
import userLogRead from './userLog/read/userLogRead.definition'
import variableAnalyze from './variable/analyze/variableAnalyze.definition'
import variableItemsExport from './variable/export/variableItemsExport.definition'
import variableList from './variable/list/variableList.definition'
import viewList from './view/list/viewList.definition'

export default [
  agentReportPolygonInsight,
  generateAgentReportHeatmapData,
  searchAgentIntersections,
  appSebraeAttendanceMedianStats,
  appSebraeAttendanceMetrics,
  appSebraeNewAttendance,
  synchronizeAppSebrae,
  synchronizeAppSebraeV2Backfill,
  appSebraeAtendimentoRead,
  attendanceGeoReport,
  appSebraeAttendanceLocationStats,
  attendanceRadar,
  fetchAttendanceProximity,
  fetchItinerary,
  fetchLegalEntityDetails,
  fetchLegalEntityItineraryStatus,
  generateItinerary,
  polygonInsight,
  agentPolygonInsight,
  geoSearch,
  legalEntityInsight,
  legalEntityNewlyOpened,
  legalEntitySearchWithGeo,
  legalEntityAppSebraeAttendanceStats,
  reverseGeocoding,
  appSebraeSearchAddress,
  appSebraeSearchAddressResolve,
  searchLegalEntity,
  selectItinerary,
  appSebraeAttendanceStats,
  agentAvailabilityCheck,
  agentAvailabilityStop,
  agentCheckStream,
  agentGeolocation,
  agentRequestClose,
  agentRequestList,
  agentRequestStart,
  agentRequestResponse,
  entrepreneurAgentCheck,
  entrepreneurAgentCloseRequest,
  entrepreneurAgentRequestDetail,
  entrepreneurAgentRequest,
  entrepreneurAgentRequestHistory,
  expiredAttendanceCancellation,
  appSebraeMobilityImageProxy,
  operationalMonitoring,
  operationalMonitoringSnapshot,
  fetchAttendantFromRadarAli,
  attendantRead,
  attendantServiceUnitRead,
  seedCityGovernmentTransparency,
  cityCensusByAreaRead,
  cityCensusByPopulationRead,
  fetchLatestCityCensus,
  cityIbgeCensusRead,
  seedCityCensus,
  legalEntityUnnestCnaeRead,
  cnaeRead,
  updateCnaes,
  cnaeClassRead,
  cnaeDivisionRead,
  cnaeGroupRead,
  cnaeSectionRead,
  cnaeSegmentRead,
  cnaeSubclassRead,
  fetchCourseProduct,
  courseProductRead,
  courseRegisterIndividualRead,
  fetchDataSourceHelpers,
  dataSourceRead,
  distinctLegalEntitiesEmissorNfeStats,
  distinctLegalEntitiesEmissorNfeSize,
  eadEnrollmentStats,
  legalEntityEadAttendanceStats,
  eadPortfolioEnrollmentStats,
  eadPortfolioAttendanceStats,
  eadAttendanceStats,
  establishmentRead,
  fetchOpenStreetMapId,
  cityRead,
  geoCommunityCreate,
  geoCommunityDelete,
  geoCommunityFetch,
  geoCommunityList,
  geoCommunityUpdate,
  countryRead,
  fetchAllDistricts,
  fetchDistricts,
  fetchBuildings,
  geoUpdateOrchestrator,
  geocodeAddress,
  legalEntityMassGeocode,
  processAddresses,
  searchAddress,
  streetSearchRefreshViews,
  legalEntityMassPartialGeocode,
  geoList,
  macroRegionRead,
  mesoRegionRead,
  microRegionRead,
  geoMunicipalityImportUrbanArea,
  geoNeighborhoodCoverageAfter,
  geoNeighborhoodEditCoverageArea,
  geoNeighborhoodFetch,
  fetchShapesFromOpenStreetMap,
  neighborhoodLowerQualityBoundaries,
  neighborhoodProcess,
  neighborhoodNewShapes,
  seedNeighborhoodNullableCenter,
  neighborhoodRead,
  geoNeighborhoodSmartMapping,
  geoReverseGeocoding,
  ruralEnvironmentalRegistryFetch,
  ruralEnvironmentalRegistryProcess,
  fetchOpenStreetMapStateId,
  stateRead,
  fetchAllRoads,
  fetchAllStreetsAndWays,
  fetchStreetsAndWays,
  fetchStreetsFromIbge,
  streetFullGeocoding,
  streetRead,
  refreshPgRoutingNetwork,
  seedBrasiliaAbbreviatures,
  seedStreetCollection,
  seedStreetRoadReference,
  districtStreetIntersectionProcess,
  districtStreetIntersectionRead,
  neighborhoodStreetIntersectionProcess,
  neighborhoodStreetIntersectionRead,
  fetchAllSuburbs,
  fetchSuburbs,
  geoSyncFetch,
  updateGeoSchema,
  wayRead,
  indicatorTrends,
  individualAnonymization,
  individualCpfValidator,
  individualFetch,
  individualRead,
  buildInsightsExport,
  insightSendEmail,
  insightList,
  insightRead,
  insightTopInsightsByRelevanceRead,
  insightSolutionSearch,
  kpiYearlyCumulativeStats,
  cnpjValidator,
  createLegalEntitySearchIndex,
  legalEntityFetch,
  legalEntityFetchLogs,
  legalEntityRead,
  legalEntityRevalidateLocation,
  legalEntityStats,
  attendanceRefreshViews,
  disproportionatePublicRead,
  legalEntityAttendanceFetch,
  legalEntityAttendanceList,
  legalEntityAttendanceRead,
  legalEntityAttendanceAttendantRead,
  legalEntityAttendanceDataSourceRead,
  prependCommaAtCnaes,
  legalEntityCnaeRead,
  seedLegalEntityCnaes,
  legalEntityGeoprocessingAfterProcess,
  generateHeatmapData,
  courseEvasionRead,
  eadReadCompany,
  eadReadEnrollment,
  eadReadStudent,
  eadReadStudentCompany,
  productMetricRead,
  mapDemarcationExportEntities,
  mapDemarcationReport,
  legalEntityGeoprocessingProcess,
  radar,
  legalEntityGeoprocessingRead,
  legalEntityIndividualRead,
  fetchLegalEntityIndicators,
  legalEntityIndicatorsRead,
  fetchLegalEntityAttendanceSize,
  legalNatureRead,
  llmChatCreate,
  llmChatDelete,
  llmChatGet,
  llmChatList,
  llmChatUpdate,
  llmChatMessageCreate,
  migrationMigrateOlap,
  migrationMigrateOltp,
  fampeAttendedEntitiesImport,
  fetchMonitorUploadUrl,
  monitorCourseClassesMetricsImport,
  monitorEmissorServiceAggregateImport,
  monitorProductMetricImport,
  monitorProductYearlyCumulativeImport,
  monitorProductMetricStats,
  monitorUsageAnalyticsSummary,
  getMonitorUserPermissions,
  updateMonitorUserPermissions,
  monitorUserReportPreferences,
  monitorAttendanceEntityDistinctStats,
  monitorCourseClassesMetricsStats,
  monitorProductMetricIdsImport,
  deregisterDevice,
  attendanceAlertAction,
  sendAttendanceUrgencyAlertEmail,
  sendTimeSeriesAlertEmail,
  systemSendEmail,
  getNotifications,
  getNotificationSettings,
  readNotification,
  registerNewDevice,
  sendTimeSeriesNotification,
  updateTimeSeriesNotificationSettings,
  productMetricIdsStats,
  reportRead,
  reportOutputRead,
  segmentRead,
  agentPolygonSmartMapping,
  agentPolygonSmartMappingServiceArea,
  geographicalContainment,
  serviceUnitGeocode,
  serviceUnitGeoprocessingRead,
  streetViewReverseGeocoding,
  fetchSummary,
  abortPendingUserQueries,
  appSebraeDistantAttendanceStats,
  systemCheck,
  systemCheckImports,
  importCagedData,
  systemImportEad,
  importFtpPostgresDumps,
  monitorStats,
  overviewStats,
  systemPrepareCache,
  systemPropagateToOlap,
  systemExportPostgresDump,
  systemExportRfbSftp,
  systemImportFailureReporter,
  systemImportPostgresDump,
  systemImportSebraeNaSuaEmpresa,
  systemSynchronizeAttendanceOlap,
  systemUserAuthEventLog,
  timeSeriesRead,
  fetchLegalEntitiesCoordinates,
  userLogRead,
  variableAnalyze,
  variableItemsExport,
  variableList,
  viewList
]
